<template>
  <v-container id="members" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <div class="mt-2 px-5 py-5 elevation-6 rounded">
          <div class="d-flex justify-space-between">
            <div class="d-flex action">
              <!-- <v-sheet
            color="primary "
            elevation="6"
            class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
            dark
            :max-width="65"
            @click="vue='creer',getSaison(),init()"
            style="cursor: pointer"
          >
            <v-icon size="32">mdi-pencil</v-icon>
            <span class="text-caption text-uppercase">Editer</span>
          </v-sheet> -->
              <!-- <v-sheet
          color="primary "
          elevation="6"
          class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
          dark
          :max-width="65"
          @click="''"
          style="cursor: pointer"
          >
            <v-icon size="32">mdi-clipboard-text</v-icon>
            <span class="text-caption text-uppercase">Suivre</span>
          </v-sheet>  -->
            </div>
            <!-- <div class="d-flex save">
        
          <v-sheet
            :color="create.save || update.save || add.save?'indigo':'grey'"
            elevation="6"
            class="mr-5 d-flex text-start align-center justify-center flex-column v-card--material__heading mb-n6 pa-3"
            dark
            :max-width="80"
            @click="save()"
            style="cursor: pointer"
          >
            <v-icon  size="32">mdi-content-save</v-icon>
            <span class="text-caption text-uppercase">Enregistrer</span>
          </v-sheet>
        </div>    -->
          </div>
          <div v-if="vue == 'creer' || vue == 'modifier' || vue == 'voir-attr'">
            <v-simple-table style="margin-top: 15px">
              <!-- <thead>
              <tr> -->
              <!-- <th class="primary--text">Saison</th> -->
              <!-- <th class="primary--text">Type</th> -->
              <!-- <th class="primary--text">Entraîneur</th> -->
              <!-- <th colspan="2" class="primary--text"></th>
              </tr>
            </thead> -->
              <tbody>
                <tr>
                  <td>
                    <v-responsive class="mx-0" max-width="150">
                      <v-select
                        v-model="create.saison"
                        :placeholder="'Saison'"
                        :items="saison"
                      ></v-select>
                    </v-responsive>
                  </td>
                  <!-- <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="vue='creer',controlVoir()" v-model="create.type" :placeholder="'Type'" :items="[{text:'Tous',value:null},{text:'Enfant',value:1},{text:'Adulte',value:2}]"></v-select>
                  </v-responsive>
                </td> -->
                  <!-- <td>
                  <v-responsive
                    class="mx-0"
                    max-width="150"
                  >
                    <v-select @change="controlVoir()" v-model="create.trainer" :placeholder="'Entraîneurs'" :items="trainer"></v-select>
                  </v-responsive>
                </td> -->
                  <td>
                    <v-btn
                      @click="getAttrTrainer()"
                      class="mx-auto"
                      small
                      :disabled="create.saison == '' ? true : false"
                      color="green"
                      >Voir</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <!-- <div v-if="vue=='creer'">
          
          <v-simple-table v-if="horaire.length">
            <thead>
              <tr>
                <th class="primary--text">ID</th>
                <th class="primary--text">Catégorie</th>
                <th class="primary--text">localisation</th>
                <th class="primary--text">Créneau(x)</th>
                <th class="primary--text">Select</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in horaire" :key="index" @dblclick="vue='modifier',assignUpdate(item), itemUpdate=item, selected=[], trash.save=false">
                <td>
                  {{index + 1}}
                </td>
                <td>
                  {{ capitalization(item.categorie)}}
                </td>
                <td>
                  {{item.location}}
                </td>
                <td>{{item.creneau.length}}</td>
                <td>
                  <v-checkbox
                    :key="item.ref"
                    v-model="selected"
                    :value="JSON.stringify(item.creneau)"
                    @change="controlSelect()"
                  ></v-checkbox>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
       </div> -->
            <!-- <div v-if="vue=='modifier'">
        <div class="primary--text px-5 py-5">{{ capitalization(itemUpdate.categorie) }} / {{ itemUpdate.location }} : </div>
        <v-simple-table>
              <thead>
                <tr>
                  <th class="primary--text">Jour</th>
                  <th class="primary--text">Creneau</th>
                  <th class="primary--text">Description</th>
                  <th class="primary--text">Quota</th>
                  <th class="primary--text">Select</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in itemUpdate.creneau" :key="index">
                  <td>{{item.jour}}</td>
                  <td>{{item.creneau}}</td>
                  <td>{{ item.description.substr(0,300) }}</td>
                  <td>{{item.quotas>0?item.quotas:"aucun"}}</td>
                  <td>
                    <v-checkbox
                    :key="item.ref+index"
                    v-model="selected"
                    :value="item.ref"
                    @change="controlSelect()"
                    ></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
       </div>  -->
            <div v-if="vue == 'voir-attr'" style="width: 100%">
              <div v-for="(value, i) in lookAttr" :key="i">
                <v-chip class="black--text px-4 py-4 mt-5"
                  >{{ capitalization(i) }} :
                </v-chip>

                <v-simple-table dense>
                  <thead>
                    <tr>
                      <!-- <th class="primary--text">Jours</th>
                  <th class="primary--text">Creneaux</th> -->
                      <!-- <th class="primary--text">Description</th> -->
                      <!-- <th class="primary--text">Quota</th> -->
                      <th colspan="3" class="primary--text select">Editer</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in value" :key="index">
                    <tr>
                      <td>{{ item.jour }}</td>
                      <td>{{ item.creneau }}</td>
                      <!-- <td>{{ item.description.substr(0,300) }}</td> -->
                      <!-- <td>{{item.quotas>0?item.quotas:"aucun"}}</td> -->
                      <td class="select">
                        <v-icon
                          @click="
                            getAdherentByCreneau(item.ref),
                              (dialog = true),
                              (dialogTitle = `${capitalization(i)}`),
                              (dialogSubTitle = `${item.jour} ${item.creneau}`),
                              (ref_creneau = item.ref),
                              (day = dayFilter[item.jour])
                          "
                          size="20"
                          >mdi-pencil</v-icon
                        >
                        <!-- <v-icon @click="getAdherentByDate(item.ref),getAdherentByCreneau(item.ref),dialog=true, dialogTitle=`${capitalization(i)}`, dialogSubTitle=`${item.jour} ${item.creneau}`, ref_creneau= item.ref, day=dayFilter[item.jour]" size="20">mdi-pencil</v-icon> -->
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- Dialog -->
    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable persistent max-width="320px">
        <v-card>
          <v-card-title
            class="text-start"
            style="padding: 6px 12px; font-size: 14px"
            >{{ dialogTitle }}</v-card-title
          >
          <v-card-subtitle
            class="text-start"
            style="padding: 6px 12px; font-size: 12px"
            >{{ dialogSubTitle }}</v-card-subtitle
          >
          <v-card-subtitle
            class="text-start"
            style="margin: 0; padding: 0 12px; font-size: 12px"
          >
            <v-row>
              <v-col cols="5">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-left="40"
                  transition="scale-transition"
                  min-width="auto"
                  max-height="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      style="margin: 0 !important; padding: 0 !important"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    :allowed-dates="allowedDates"
                    @input="
                      getAdherentByDate(ref_creneau),
                        (menu2 = false),
                        (enregistrer = false)
                    "
                    :first-day-of-week="1"
                    locale="fr-fr"
                    style="
                      margin-top: 0 !important;
                      margin-bottom: 0 !important;
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-subtitle
            class="text-start"
            style="padding: 6px 12px; font-size: 12px"
            >{{
              `${dialogSelected.length}/${adherentEmargement.length}`
            }}
            présents</v-card-subtitle
          >
          <v-divider></v-divider>
          <v-card-text style="height: 500px; padding: 5px 10px">
            <v-checkbox
              v-for="(item, index) in adherentEmargement"
              :key="item.ref + index"
              :id="item.ref + index"
              :value="item.ref"
              v-model="dialogSelected"
              hide-details
              ><template #label>
                <div style="color: #000000; font-weight: 600">
                  {{ `${item.prenom} ${item.nom}` }} <br /><span
                    style="font-size: 12px; color: rgb(101, 101, 101)"
                    >{{
                      `${
                        item.tel != "" ? "(&nbsp;" + item.tel + "&nbsp;)" : ""
                      }`
                    }}</span
                  >
                </div>
              </template></v-checkbox
            >
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" @click="enregistrerEmargement()">
              Enregistrer
              <v-icon v-if="enregistrer" class="ml-2">mdi-check</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                (enregistrer = false),
                  (dialogSelected = []),
                  (dialog = false),
                  (date = dateInit)
              "
            >
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Dialog -->
  </v-container>
</template>
<script>
import moment from "moment";
import Inscriptions from "@/services/Inscription.js";
import Categories from "@/services/Categorie.js";
import Horaires from "@/services/Horaire.js";
import Horaire_days from "@/services/Horaire_day.js";
import Salles from "@/services/Salle.js";
import Users from "@/services/User.js";
import Emargements from "@/services/Emargement.js";
export default {
  name: "Inscriptions",
  data: () => ({
    enregistrer: false,
    day: null,
    dayFilter: {
      Dimanche: 0,
      Lundi: 1,
      Mardi: 2,
      Mercredi: 3,
      Jeudi: 4,
      Vendredi: 5,
      Samedi: 6,
    },
    // Horaire
    saison: [],
    categorie: [],
    salle: [],
    arraySalle: [],
    horaire: [],
    trainer: [],
    lookAttr: [],
    selectedVoirAttr: [],
    selectedVoirAttrCopy: [],
    arrayInscription: [],
    arrayTrainer: [],
    // Horaire

    // Dialog
    dialog: false,
    dialogSelected: [],
    dialogTitle: "",
    dialogSubTitle: "",
    adherentNumber: 0,
    // date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    // date: new Date(moment().format("YYYY-MM-DD")),
    date: "",
    dateInit: "", // date: moment().format("DD/MM/YYYY"),
    // dateInit: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), // date: moment().format("DD/MM/YYYY"),
    modal: false,
    menu2: false,
    adherentEmargement: [],
    ref_creneau: "",
    // Dialog

    selected: [],
    trash: {
      save: false,
    },

    itemUpdate: {},

    add: {
      save: false,
      ref: null,
      creneau: [
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
      ],
    },

    update: {
      save: false,
      ref: null,
      saison: "",
      type: null,
      categorie: "",
      description: "",
      localisation: "",
      adresse: "",
      switchReadOnly: false,

      creneau: [
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
      ],
    },

    voir: {
      saison: "",
      type: null,
      trainer: "",
    },

    create: {
      save: false,
      ref: null,
      saison: "",
      type: null,
      categorie: "",
      trainer: "",
      localisation: "",
      switchReadOnly: false,

      creneau: [
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
        {
          jour: "",
          time2: null,
          time: null,
          description2: "",
          quota: "",
          modal2: false,
          modal: false,
        },
      ],
    },
    arrayInscription: [],
    vue: "creer",
  }),
  mounted() {
    this.getSaison();
  },
  watch: {},
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    allowedDates(date) {
      // Créer une instance de date pour vérifier le jour
      const day = new Date(date).getDay(); // 0 = Dimanche, 1 = Lundi, ..., 6 = Samedi
      return day === this.day; // Autoriser uniquement Mardi (2) et Jeudi (4)
    },
    async enregistrerEmargement() {
      let adherentEmargementFilterPR = this.adherentEmargement.filter((el) =>
        this.dialogSelected.includes(el.ref)
      );
      let adherentEmargementFilterABS = this.adherentEmargement.filter(
        (el) => !this.dialogSelected.includes(el.ref)
      );
      adherentEmargementFilterPR.map((el) => (el["presence"] = true));
      adherentEmargementFilterABS.map((el) => (el["presence"] = false));
      let emargement = [
        ...adherentEmargementFilterPR,
        ...adherentEmargementFilterABS,
      ];

      if (this.date != "") {
        let emargementSend = {};
        emargementSend[this.date] = {};
        emargementSend[this.date][this.ref_creneau] = emargement;
        let options = {
          ref_user: this.$store.state.currentUser.user.ref_user,
          ref_inscription: this.create.saison,
          ref_licencie_emargement: JSON.stringify(emargementSend),
        };
        console.log("options", options);

        const response = await Emargements.saveEmargementLicencie(options);
        if (response) {
          this.enregistrer = true;
        }
      }
    },
    async getAdherentByDate(ref) {
      const response = await Emargements.getEmargementByDate({
        ref_creneau: ref,
        ref_inscription: this.create.saison,
        ref_user: this.$store.state.currentUser.user.ref_user,
        date: moment(this.computedDateFormatted, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
      });
      this.dialogSelected = [];
      console.log("response", response);
      response.map((el) => {
        if (el.presence) {
          this.dialogSelected.push(el.ref);
        }
      });
    },
    async getAdherentByCreneau(ref) {
      // this.dialogSelected = []
      const response = await Emargements.getAdherent({
        ref_creneau: ref,
        ref_inscription: this.create.saison,
      });
      console.log("response getAdherentByCreneau", response);
      this.adherentEmargement = response;

      this.adherentEmargement.sort((a, b) => {
        // Comparer les noms
        if (a.nom < b.nom) return -1;
        if (a.nom > b.nom) return 1;

        // Si les noms sont égaux, comparer les prénoms
        if (a.prenom < b.prenom) return -1;
        if (a.prenom > b.prenom) return 1;

        return 0; // Identiques
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    arraysEqual(arr1, arr2) {
      // Vérifier si les deux tableaux ont la même longueur
      if (arr1.length !== arr2.length) return false;

      // Trier les tableaux et comparer chaque élément
      const sortedArr1 = [...arr1].sort();
      const sortedArr2 = [...arr2].sort();

      return sortedArr1.every((value, index) => value === sortedArr2[index]);
    },
    async getAttrTrainer() {
      this.selectedVoirAttr = [];
      this.selectedVoirAttrCopy = [];
      const response = await Emargements.getAttr({
        ref_user: this.$store.state.currentUser.user.ref_user,
        ref_inscription: this.create.saison,
      });
      console.log("response getAttrTrainers", response);
      this.lookAttr = response;
      this.vue = "voir-attr";
      Object.values(response).map((el) =>
        el.map((e) => this.selectedVoirAttrCopy.push(e.ref))
      );
      Object.values(response).map((el) =>
        el.map((e) => this.selectedVoirAttr.push(e.ref))
      );
      console.log("this.selectedVoirAttr", this.selectedVoirAttr);
    },
    init() {
      this.horaire = [];
      Object.assign(this.$data.create, this.$options.data().create);
      Object.assign(this.$data.update, this.$options.data().update);
      Object.assign(this.$data.voir, this.$options.data().voir);
      Object.assign(this.$data.add, this.$options.data().add);
      Object.assign(this.$data.trash, this.$options.data().trash);
      this.itemUpdate = {};
      this.selected = [];
    },
    async getSalleByInscription(options) {
      let arraySalle = await Salles.getByInscription(options);
      arraySalle.forEach((el) => {
        this.salle.push({ text: el.nom, value: el.ref });
      });
    },

    getInscriptionByID(id) {
      let findEl = this.arrayInscription.find((el) => el.id == id);
      console.log("findEl", findEl);
      return findEl.ref;
    },

    assignUpdate(item) {
      console.log("item", item);
      if (this.vue == "modifier") {
        let options = {
          type: item.type,
          ref_inscription: item.ref_inscription,
        };
        this.getCategorieByTypeInscription(options);
        this.getSalleByInscription(options);

        console.log(
          "saison ref ",
          this.getInscriptionByID(item.id_inscription)
        );
        this.update.saison = item.ref_inscription;
        this.update.ref = item.ref;
        this.update.type = item.type;
        this.update.categorie = item.categorie_ref;
        this.update.description = item.description;
        this.update.localisation = item.ref_location;
        this.update.adresse = item.adresse;
        this.update.switchReadOnly = item.readonly;

        this.add.ref = item.ref;
      }

      if (this.vue == "modifier-2") {
        this.update.ref = item.ref;
        this.update.creneau[0].jour = item.jour;
        this.update.creneau[0].time = item.creneau.split("/")[0];
        this.update.creneau[0].time2 = item.creneau.split("/")[1];
        this.update.creneau[0].description2 = item.description;
        this.update.creneau[0].quota = item.quotas;
      }
    },

    controlSelect() {
      if (
        this.selected.length &&
        (this.vue == "creer" || this.vue == "modifier")
      ) {
        this.trash.save = true;
      } else {
        this.trash.save = false;
      }

      if (
        (this.vue == "creer" || this.vue == "modifier") &&
        this.selected.length &&
        this.create.trainer.length
      ) {
        console.log("this.selected", this.selected);
        this.create.save = true;
      } else if (
        this.vue == "voir-attr" &&
        !this.arraysEqual(this.selectedVoirAttr, this.selectedVoirAttrCopy)
      ) {
        this.create.save = true;
      } else {
        this.create.save = false;
      }
    },

    async supprimer() {
      console.log("this.selected", this.selected);
      if (this.trash.save && this.vue == "creer") {
        let deleteSelected = await Horaires.delete({
          array_ref: this.selected,
        });
        console.log("deleteSelected save", deleteSelected);
        this.trash.save = !deleteSelected;
        this.selected = [];
        let options = {
          ref_inscription: this.voir.saison,
          type: this.voir.type,
        };
        this.getHoraire(options);
      }

      if (this.trash.save && this.vue == "modifier") {
        let deleteSelected = await Horaire_days.delete({
          array_ref: this.selected,
        });
        console.log("deleteSelected save", deleteSelected);
        this.trash.save = !deleteSelected;
        this.itemUpdate.creneau = JSON.parse(
          JSON.stringify(this.itemUpdate.creneau)
        ).filter((item) => !this.selected.includes(item.ref));
        this.selected = [];
      }
    },

    async getHoraire(options) {
      let arrayHoraire = await Horaires.getBySaison(options);
      console.log("arrayHoraires.data", arrayHoraire);
      this.horaire = arrayHoraire;
    },

    async getCategorieByTypeInscription(options) {
      let arrayCategorie = await Categories.getByTypeAndIscription(options);
      console.log("arrayInscription.data", arrayCategorie);
      this.categorie = [];
      arrayCategorie.forEach((element) => {
        this.categorie.push({
          text: `${this.capitalization(element.niveau)} (${element.startAge}${
            element.endAge ? "/" + element.endAge + " ans" : ""
          })`,
          value: element.ref,
        });
      });
    },

    capitalization(string) {
      return string[0].toUpperCase() + string.slice(1);
    },
    async getSaison() {
      this.arrayInscription = await Inscriptions.get();
      console.log("arrayInscription.data", this.arrayInscription);
      this.arrayInscription.forEach((element) => {
        this.saison.push({ text: element.saison, value: element.ref });
        if (element.actif) {
          this.create.saison = element.ref;
          this.getAttrTrainer();
        }
      });
    },
    async save() {
      console.log("save enter");
      if (this.create.save) {
        if (this.vue == "voir-attr") {
          let options = {
            typeAttr: "update",
            ref_user: this.create.trainer,
            ref_inscription: this.create.saison,
            ref_horaire_day: JSON.stringify(this.selectedVoirAttr),
          };
          const response = await Emargements.attribuer(options);

          if (response) {
            const responseAttr = await Emargements.getAttr({
              ref_user: this.create.trainer,
              ref_inscription: this.create.saison,
            });
            console.log("response getAttrTrainers update", responseAttr);
            this.lookAttr = responseAttr;
            this.create.save = false;
          }
        }
      }

      if (this.create.save) {
        if (this.vue == "creer") {
          console.log("this.selected test", this.selected);
          let ref_horaire_day = [];
          this.selected.map((el) => {
            JSON.parse(el).map((e) => ref_horaire_day.push(e.ref));
          });
          console.log("ref_horaire_day", ref_horaire_day);
          console.log("this.create.trainer", this.create.trainer);
          let options = {
            typeAttr: "create",
            ref_user: this.create.trainer,
            ref_inscription: this.create.saison,
            ref_horaire_day: JSON.stringify(ref_horaire_day),
          };

          const response = await Emargements.attribuer(options);
          if (response) {
            Object.assign(this.$data.create, this.$options.data().create);
            this.selected = [];
            this.horaire = [];
            this.create.save = false;
          }
        }
        if (this.vue == "modifier") {
          let options = {
            typeAttr: "create",
            ref_user: this.create.trainer,
            ref_inscription: this.create.saison,
            ref_horaire_day: JSON.stringify(this.selected),
          };
          const response = await Emargements.attribuer(options);
          if (response) {
            Object.assign(this.$data.create, this.$options.data().create);
            this.selected = [];
            this.horaire = [];
            // this.itemUpdate.creneau=[]
            this.create.save = false;
            this.vue = "creer";
          }
        }
      }

      if (this.vue == "modifier-2" && this.update.save) {
        console.log("save 4", this.update);
        let putHoraireDay = await Horaire_days.put({
          description: this.update.creneau[0].description2,
          creneau:
            this.update.creneau[0].time + "/" + this.update.creneau[0].time2,
          jour: this.update.creneau[0].jour,
          ref: this.update.ref,
          quotas: this.update.creneau[0].quota,
        });
        console.log("putHoraireDay save", putHoraireDay);
        this.update.save = !putHoraireDay;
      }

      if (this.vue == "modifier" && this.update.save) {
        console.log("save 1", this.update);
        let putHoraire = await Horaires.put({
          location: this.update.localisation,
          readonly: this.update.switchReadOnly,
          ref: this.update.ref,
          categorie: this.update.categorie,
        });
        console.log("putHoraire save", putHoraire);
        this.update.save = !putHoraire;
        console.log("this.update.save", this.update.save);
      }

      if (this.vue == "voir" && this.create.save) {
        console.log("save 2");
        let postHoraire = await Horaires.post({
          location: this.create.localisation,

          readonly: this.create.switchReadOnly,
          type: this.create.type,
          ref: this.create.saison,
          categorie: this.create.categorie,

          creneau: this.create.creneau,
        });
        if (postHoraire) {
          Object.assign(this.$data.create, this.$options.data().create);
        }
      }
    },
    controlVoir() {
      console.log("test voir");
      if (this.vue == "creer" && this.create.saison != "") {
        this.trash.save = false;
        this.create.save = false;
        this.selected = [];
        let options = {
          ref_inscription: this.create.saison,
          type: this.create.type,
        };
        this.getHoraire(options);
      }
    },
    controlSave() {
      console.log("test");
      console.log("$refs", this.$refs);
      if (
        (this.vue == "ajouter" &&
          this.add.creneau[0].jour != "" &&
          this.add.creneau[0].time2 != null &&
          this.add.creneau[0].time != null) ||
        (this.add.creneau[1].jour != "" &&
          this.add.creneau[1].time2 != null &&
          this.add.creneau[1].time != null) ||
        (this.add.creneau[2].jour != "" &&
          this.add.creneau[2].time2 != null &&
          this.add.creneau[2].time != null) ||
        (this.add.creneau[3].jour != "" &&
          this.add.creneau[3].time2 != null &&
          this.add.creneau[3].time != null)
      ) {
        console.log("this.saisonStart 1", this.create);
        this.add.save = true;
      } else {
        console.log("this.saisonStart 2", this.create);
        this.add.save = false;
      }

      if (this.vue == "voir" && this.create.saison != "") {
        let options = {
          ref_inscription: this.create.saison,
          type: this.create.type,
        };
        if (this.create.type != null) {
          this.getCategorieByTypeInscription(options);
        }
        this.getSalleByInscription(options);
      }

      if (
        (this.vue == "voir" &&
          this.create.saison != "" &&
          this.create.type != null &&
          this.create.categorie != "" &&
          this.create.localisation != "" &&
          this.create.creneau[0].jour != "" &&
          this.create.creneau[0].time2 != null &&
          this.create.creneau[0].time != null) ||
        (this.create.creneau[1].jour != "" &&
          this.create.creneau[1].time2 != null &&
          this.create.creneau[1].time != null) ||
        (this.create.creneau[2].jour != "" &&
          this.create.creneau[2].time2 != null &&
          this.create.creneau[2].time != null) ||
        (this.create.creneau[3].jour != "" &&
          this.create.creneau[3].time2 != null &&
          this.create.creneau[3].time != null)
      ) {
        console.log("this.saisonStart 1", this.create);
        this.create.save = true;
      } else {
        console.log("this.saisonStart 2", this.create);
        this.create.save = false;
      }

      if (
        (this.vue == "modifier" &&
          this.update.saison != this.itemUpdate.ref_inscription &&
          this.itemUpdate.ref_inscription != undefined) ||
        (this.update.type != this.itemUpdate.type &&
          this.itemUpdate.type != undefined) ||
        (this.update.categorie != this.itemUpdate.categorie_ref &&
          this.itemUpdate.categorie_ref != undefined) ||
        (this.update.localisation != this.itemUpdate.ref_location &&
          this.itemUpdate.ref_location != undefined) ||
        (this.update.switchReadOnly != this.itemUpdate.readonly &&
          this.itemUpdate.readonly != undefined)
      ) {
        console.log("this.saisonStart 1", this.update);
        console.log("this.saisonStart item 1", this.itemUpdate);
        this.update.save = true;
      } else {
        console.log("this.saisonStart 2", this.update);
        this.update.save = false;
      }

      if (this.vue == "modifier-2") {
        if (
          (this.update.creneau[0].jour != this.itemUpdate.jour &&
            this.itemUpdate.jour != undefined) ||
          (this.update.creneau[0].time !=
            this.itemUpdate.creneau.split("/")[0] &&
            this.itemUpdate.creneau != undefined) ||
          (this.update.creneau[0].time2 !=
            this.itemUpdate.creneau.split("/")[1] &&
            this.itemUpdate.creneau != undefined) ||
          (this.update.creneau[0].description2 != this.itemUpdate.description &&
            this.itemUpdate.description != undefined) ||
          (this.update.creneau[0].quota != this.itemUpdate.quotas &&
            this.itemUpdate.quotas != undefined)
        ) {
          console.log("this.saisonStart 1", this.update);
          this.update.save = true;
        } else {
          console.log("this.saisonStart 2", this.update);
          this.update.save = false;
        }
      }
    },
    Moment(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async getInscription() {
      this.arrayInscription = await Inscriptions.get();
    },
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  width: 250px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 45px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th.select,
td.select {
  text-align: right !important;
}

.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td.select
  .v-input__slot {
  justify-content: end !important;
}
</style>
